import { useEffect, useState } from 'react';
import { Button, ControlLabel, FormControl, FormGroup, Modal, Table } from 'react-bootstrap';

export interface ITrackedChange {
    propertyName: string,
    columnLabel: string,
    before: string,
    after: string
}

interface IProps {
    show: boolean,
    changes: ITrackedChange[],
    onConfirm: (reasonsByProperty: Record<string, string>) => void,
    onClose: () => void
}

const PerFieldReasonModal = (props: IProps) => {
    const [reasons, setReasons] = useState<Record<string, string>>({});

    useEffect(() => {
        if (props.show) setReasons({});
    }, [props.show]);

    const setReason = (propertyName: string, value: string) => {
        setReasons(prev => ({ ...prev, [propertyName]: value }));
    };

    const allFilled = props.changes.every(c => (reasons[c.propertyName] ?? '').trim().length > 0);

    const handleConfirm = () => {
        if (!allFilled) return;
        props.onConfirm(reasons);
    };

    return (
        <Modal backdrop='static' show={props.show} onHide={props.onClose} bsSize='large'>
            <Modal.Header closeButton>
                <Modal.Title>Reasons for Tracked Changes</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>Each tracked change requires its own reason. Reasons are logged in the Activity Log.</p>
                <Table striped>
                    <thead>
                        <tr>
                            <th style={{ width: '30%' }}>Field</th>
                            <th style={{ width: '20%' }}>Before &rarr; After</th>
                            <th>Reason</th>
                        </tr>
                    </thead>
                    <tbody>
                        {props.changes.map(c => (
                            <tr key={c.propertyName}>
                                <td>{c.columnLabel}</td>
                                <td>{c.before} &rarr; {c.after}</td>
                                <td>
                                    <FormGroup validationState={(reasons[c.propertyName] ?? '').trim().length > 0 ? null : 'error'} style={{ marginBottom: 0 }}>
                                        <FormControl
                                            componentClass='textarea'
                                            rows={2}
                                            placeholder='Reason (required)'
                                            value={reasons[c.propertyName] ?? ''}
                                            onChange={(e: any) => setReason(c.propertyName, e.target.value)}
                                        />
                                    </FormGroup>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
                {!allFilled && <ControlLabel style={{ color: '#a94442' }}>All reasons are required to save.</ControlLabel>}
            </Modal.Body>
            <Modal.Footer>
                <Button bsStyle='primary' disabled={!allFilled} onClick={handleConfirm}>Save Changes</Button>
                <Button onClick={props.onClose}>Cancel</Button>
            </Modal.Footer>
        </Modal>
    );
};

export default PerFieldReasonModal;
